import React from 'react'
import injectStyles from 'react-jss'
import styles from '../styles'

const UnreadIndicatorView = ({ children, classes }) => {
  return (
    <div className={classes.wrapper}>
      <span className={classes.label}>{children}</span>
    </div>
  )
}

export default injectStyles(styles)(UnreadIndicatorView)



// WEBPACK FOOTER //
// ./src/Components/ChatUnreadIndicator/component/UnreadIndicatorView.js